export default __webpack_public_path__ + "static/media/policies.2a6da0ad.png";